import {useLazyQuery} from "@apollo/client/react";
import {Mutation, MutationUpdateWebsiteConfigArgs, Query, WebsiteConfig} from "../graphql/generated/graphql-main.tsx";
import {apollo11, gqlTemplates} from "../utils/gql-client.ts";
import {useXDispatch, useXSelector} from "../store/hooks.ts";
import {coreActions} from "../store/slice-core";
import {useEffect} from "react";
import {CoreStateType} from "../store/slice-core/types.ts";
import {empty, gqlClean} from "../utils/utils.ts";
import {DocumentNode} from "@apollo/client";

const set = coreActions.$setSiteConfig;
// data type in Redux Store core slice
const dtype: keyof CoreStateType = "site_config";
// GraphQL document node to query for the data type
const gnodeQuery: DocumentNode = gqlTemplates.websiteConfig;
const gnodeMutation: DocumentNode = gqlTemplates.updateWebsiteConfig;
// GraphQL mutation result data key
const gkey: keyof Query = "websiteConfig";

export default function useSiteConfig<T extends WebsiteConfig>() {
    const dispatch = useXDispatch();
    const $config = useXSelector(s => s.core[dtype] as T);

    const [fetch, {loading}] = useLazyQuery<Query>(gnodeQuery, {fetchPolicy: "cache-and-network"});

    const load = async () => {
        const {data} = await fetch();
        if (data?.[gkey] == null) return;
        dispatch(set(data?.[gkey] as T));
    }

    const persist = async (payload: WebsiteConfig) => {
        // update local redux store
        dispatch(set(gqlClean(payload)));

        // send config to the server to update in db
        await apollo11.mutate<Mutation, MutationUpdateWebsiteConfigArgs>({
            mutation: gnodeMutation,
            variables: {cfg: gqlClean(payload)}
        });
    }

    useEffect(() => {
        if (!empty($config)) return;
        load();
    }, [$config]);

    return {
        $config,
        persist,
        loading
    }
}